<template>
  <Card :title="$t('global.solr')" logo="solr">
    <CardActionContent :buttons="getButtons()">
      <template v-if="container" #description>
        <LoadingState v-if="isLoading()" class="mb-2" />
        <ErrorState v-else-if="isErrored()" />
        <CardListContent v-else :list="getInfo()" />
      </template>
    </CardActionContent>
  </Card>
</template>

<script>
import { computed, ref } from "@vue/composition-api";
import Card from "@/components/display/Card";
import CardActionContent from "@/components/display/card-sub-components/CardActionContent";
import CardListContent from "@/components/display/card-sub-components/CardListContent";
import ErrorState from "@/components/display/ErrorState";
import LoadingState from "@/components/display/LoadingState";
import NavLink from "@/classes/NavLink";
import SolrDisableModal from "@/components/smart/modals/SolrDisable";
import SolrEnableModal from "@/components/smart/modals/SolrEnable";
import SolrResizeModal from "@/components/smart/modals/SolrResize";
import store from "@/store";

export default {
  name: "Solr",
  components: {
    CardActionContent,
    LoadingState,
    ErrorState,
    Card,
    CardListContent,
  },
  props: {
    site: Object,
  },
  setup(props, { root }) {
    const container = computed(() => store.getters["containers/getSolr"]);
    const password = computed(() => store.getters["containerPassword/get"]);
    const passwordLoading = ref(false);
    const passwordErrored = ref(false);
    const isLoading = () => (container.value && !container.value.isStable) || passwordLoading.value;
    const isErrored = () => passwordErrored.value;

    // list of hostname (endpoint) and port used by elasticsearch
    const getInfo = () => {
      // if no container, or is still loading, return empty list
      if (!container.value) {
        return [];
      }

      // else return list filled with elasticsearch info
      const list = [
        {
          label: root.$t("global.endpoint"),
          content: container.value.hostname,
          canCopy: true,
        },
        {
          label: root.$t("global.port"),
          content: container.value.ports[0].publishPort,
          canCopy: true,
        },
      ];

      return list;
    };

    // shows the enable solr modal
    const enable = () => {
      store.dispatch("modals/open", {
        template: SolrEnableModal,
        data: { site: props.site },
      });
    };

    // shows the disable solr modal
    const disable = () => {
      store.dispatch("modals/open", {
        template: SolrDisableModal,
        data: { site: props.site, container: container.value },
      });
    };

    const resize = () => {
      store.dispatch("modals/open", {
        template: SolrResizeModal,
        data: { site: props.site, container: container.value },
      });
    };

    const getButtons = () => {
      // if an elasticsearch container exists, but is not stable, don't show any buttons
      if (container.value && !container.value.isStable) {
        return [];
      }

      // if elasticsearch has been enabled, show the disable button
      if (container.value) {
        return [
          new NavLink(root.$t("global.resize"), null, resize, false, "danger"),
          new NavLink(root.$t("global.disable"), null, disable, false, "danger"),
        ];
      }

      // ... else show the enable button
      return [new NavLink(root.$t("global.enable"), null, enable, false, "primary")];
    };

    return {
      container,
      password,
      getButtons,
      getInfo,
      isLoading,
      isErrored,
    };
  },
};
</script>
